var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 356,
    viewBox: "0 0 356 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1465_6219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 358,
    height: 358
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.910156,
    y: 64.0234,
    width: 300,
    height: 300,
    rx: 7.8125,
    transform: "rotate(-12.5 -0.910156 64.0234)",
    fill: "url(#paint0_radial_1465_6219)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1465_6219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.87,
    y: 163.914,
    width: 37.1094,
    height: 37.1094,
    rx: 7.61719,
    transform: "rotate(-12.5 155.87 163.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.506,
    y: 149.648,
    width: 74.6094,
    height: 74.6094,
    rx: 7.61719,
    transform: "rotate(-12.5 133.506 149.648)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.141,
    y: 135.406,
    width: 112.109,
    height: 112.109,
    rx: 7.61719,
    transform: "rotate(-12.5 111.141 135.406)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7779,
    y: 121.156,
    width: 149.609,
    height: 149.609,
    rx: 7.61719,
    transform: "rotate(-12.5 88.7779 121.156)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4146,
    y: 106.914,
    width: 187.109,
    height: 187.109,
    rx: 7.61719,
    transform: "rotate(-12.5 66.4146 106.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.0513,
    y: 92.6718,
    width: 224.609,
    height: 224.609,
    rx: 7.61719,
    transform: "rotate(-12.5 44.0513 92.6718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6861,
    y: 78.4218,
    width: 262.109,
    height: 262.109,
    rx: 7.61719,
    transform: "rotate(-12.5 21.6861 78.4218)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.6772,
    y: 64.1718,
    width: 299.609,
    height: 299.609,
    rx: 7.61719,
    transform: "rotate(-12.5 -0.6772 64.1718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1465_6219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 154,
    width: 48,
    height: 48,
    rx: 9.30247,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.965,
    y: 154.465,
    width: 47.0698,
    height: 47.0698,
    rx: 8.83735,
    stroke: "#EAECF0",
    strokeWidth: 0.930247,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.5 167.5C177.108 167.5 175.772 168.053 174.788 169.038C173.803 170.022 173.25 171.358 173.25 172.75V175.75C172.454 175.75 171.691 176.066 171.129 176.629C170.566 177.191 170.25 177.954 170.25 178.75V185.5C170.25 186.296 170.566 187.059 171.129 187.621C171.691 188.184 172.454 188.5 173.25 188.5H183.75C184.546 188.5 185.309 188.184 185.871 187.621C186.434 187.059 186.75 186.296 186.75 185.5V178.75C186.75 177.954 186.434 177.191 185.871 176.629C185.309 176.066 184.546 175.75 183.75 175.75V172.75C183.75 169.85 181.4 167.5 178.5 167.5ZM182.25 175.75V172.75C182.25 171.755 181.855 170.802 181.152 170.098C180.448 169.395 179.495 169 178.5 169C177.505 169 176.552 169.395 175.848 170.098C175.145 170.802 174.75 171.755 174.75 172.75V175.75H182.25Z",
    fill: "#011229"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1465_6219",
    x: 152.64,
    y: 153.07,
    width: 51.721,
    height: 51.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.930247
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.930247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1465_6219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1465_6219",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1465_6219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.09 214.023) rotate(90) scale(150 150)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestAccess);
export default __webpack_public_path__ + "static/media/request_access.b09fb3409b26f350104adb344c59be7c.svg";
export { ForwardRef as ReactComponent };